import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CombinationEquationComponent } from './combination-equation/combination-equation.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports: [
    CombinationEquationComponent,
  ],
  declarations: [CombinationEquationComponent],
})
export class CombinationEquationModule { }
